/** ElementType type declaration */
export const linkType = 'link'
export type ElementType = typeof linkType | string

/** Region name type declaration */
export const topNavRegion = 'top nav'
export const pricingTableRegion = 'pricing table'
export type Region = typeof topNavRegion | typeof pricingTableRegion

/** Element name type declaration */
export const signUpStartElementName = 'sign up start'

/** Signup click payload type declaration */
export type SignupStartPayload = {
  region: Region
  type?: ElementType
}
